<template>
  <div id="dashboard_page" class="centered" v-if="loaded">

    <div class="col-md-6">
      <div id="user_welcome">
        <span>ברוך הבא,</span>
        <h3 v-text="get_me().display_name"></h3>
        <label>איש מדיה</label>
        <div class="pic_wrapper"  :style="'background-image:linear-gradient(90deg, rgba(0,0,0,0.16290266106442575) 0%, rgba(0,0,0,0) 25%, rgba(0,0,0,0.5046393557422969) 100%),url('+get_me().pic_parsed+')'">
          <div class="fade_pic"></div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="user_props">
        <div class="prop" v-if="!isNull($store.playlists)">
          <i :style="'background-image:url(' + ico_num_artists + ')'"></i>
          <div class="texts">
            <span v-text="$store.playlists.length"></span>
            <label>פלייליסטים</label>
          </div>
        </div>

        <div class="prop">
          <i :style="'background-image:url(' + ico_views + ')'"></i>
          <div class="texts">
            <span v-text="format_number(num_views)"></span>
            <label>סך כל ההאזנות</label>
          </div>
        </div>

        <div class="prop">
          <i :style="'background-image:url(' + ico_lpedia_views + ')'"></i>
          <div class="texts">
            <span v-text="format_number(num_downloads)"></span>
            <label>סך כל ההורדות</label>
          </div>
        </div>
      </div>

    </div>

    <div class="clr"></div>
    

    <div class="col-md-8">
        <div class="box">
            <h4>צפיות שלך בלינקטונים</h4>
            <LineChart :x="false" :y="true" :data="chartdata" :options="options" :legend="false" :legend_label="'צפיות בלינקטונים שלי'"></LineChart>
        </div>
        <div id="playlist_details" v-if="play_items.length > 0" >
           <div class="name">פליליסט | <span>{{play_items.playlist.name}}</span></div>
        <select @change="get_playlist()" v-model="playlist_id">
            <option v-for="item in $store.playlists" :key="item.id" :value="item.id" v-text="item.name"></option> 
        </select>
        </div>
        <div id="items_table">
            <div class="item"  v-for="(item,i) in play_items.list" :key="item.id" >
        <span class="num">{{(i+1)}} </span>
        <div class="pic" :style="'background-image:url(' + item.pic_tumb + ')'" @click="$emit('open_widget', item)"></div>
        <div class="texts">
            <h4 v-text="item.name"></h4>
        </div>
         <span class="date" v-text="item.online_date_format"></span>
        <div class="option" @click="$emit('open_widget', item)"><img src="@/assets/to_lt.svg" style="height:35px;"></div>
        <router-link :to="'/stats/' + item.id" class="option" @click="$emit('itemOpen')" style="color:#000"><i class="fas fa-chart-line"></i></router-link>
      </div>
      <div class="clr"></div>
    </div>
    </div>
    <div class="col-md-4">
        <Chat/>
        <div>
            <div id="items_table_small">
                <h3>המומלצים עבורך</h3>
         <div class="item"  v-for="item in items" :key="item.id" >
        <div class="pic" :style="'background-image:url(' + item.pic_tumb + ')'" @click="$emit('open_widget', item)"></div>
        <div class="texts">
            <h4 v-text="item.name"></h4>
        </div>
         <span class="date" v-text="item.online_date_format"></span>
        <div class="option" @click="$emit('open_widget', item)"><img src="@/assets/to_lt.svg" style="height:35px;"></div>

      </div>
      </div>
        </div>
    </div>
          <div class="clr"></div>

      </div>
      

</template>

<script>
import Chat from '../components/inbox/widget_chat.vue'
import LineChart from '@/components/new_charts/LineChart.vue';
export default {
    components: { Chat, LineChart},
  data(){
    return {
      loaded: false,
      ico_num_artists: require('@/assets/ico_num_artists.svg'),
      ico_views: require('@/assets/ico_views.svg'),
      ico_lpedia_views: require('@/assets/ico_lpedia_views.svg'),
      
      media_data: [],
      play_items: [],
      artists: [],
      playlist_id:'',
      num_views: 0,
      num_downloads: 0,
      show_linktones: true,
      items: [
      ],
      chartdata: {
        labels: ['January', 'February'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979', 
            data: [40, 20]
          }
        ]
      },
    

      
    }
  },
  methods:{
      get_playlist()
      {
          var self = this;
        this.api({ action: 'playlist/get_playlist_list', data: { id: this.playlist_id } }, function(data){ 
            self.play_items = data.data;
         
        });
     
      }
  },

  mounted(){
    this.api({ action: 'dashboard_media' }, (data) => { 
      
      this.items = data.data.items;
      this.media_data = data.data.media;
      this.num_views = data.data.num_views;
      this.num_downloads = data.data.num_downloads;

      if (!this.isNull(this.$store.playlists) && this.$store.playlists.length > 0)
      {
        this.playlist_id = this.$store.playlists[0].id;
        this.get_playlist();
      }

      this.chartdata.labels = Object.values(data.data.views).map(function(rows) { return rows.date_key});
      this.chartdata.datasets[0].data = Object.values(data.data.views).map(function(rows) { return parseInt(rows.value); });


      this.loaded = true;
    });
    

  }
  
}
</script>

<style scoped lang="scss">
#playlist_details{
    &{    display: flex;justify-content: space-between; padding-bottom: 20px; align-items: center;}
    .name{    font-size: 26px;font-family: 'almoni-dl';letter-spacing: 0;color: #333;font-weight: 600;}
    span{    color: #ff1854;}
    select{border-radius: 21.5px;padding: 9px 16px 9px 15px;font-size: 16px;color: #333333;border-color: rgba(51, 51, 51,  0.4);outline: none;}
}
#linktones_list{
  h3{font-size: 22px;margin-bottom: 20px;}
  #items_table{
  .item{
    svg{color: rgba(0, 0, 0, 0.5);}
    &{margin-bottom: 20px;}
    .num{font-size: 50px;}
    .texts{padding: 0;}
    .option{width: 7%;padding-top: 20px;}
    .date{padding: 25px 0;}
  }
}

}
  #items_table_small{
      h3{margin-bottom: 10px;}
      &{    background-color: #f5f5f5; padding:20px; border-radius: 33px; margin-top: 20px;}
      .pic{height: 60px; width: 60px; background-position: center;background-size: cover; box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.23); border-radius: 5px;}
  .item{
      h4{padding: 0;}
    svg{color: rgba(0, 0, 0, 0.5);}
    &{margin-bottom: 10px;align-items: center;display: flex;justify-content: space-between;}
    .num{font-size: 50px;}
    .texts{ text-align: right;;flex-basis: 50%;}
    .date{}
  }
}
.col-md-12{padding: 0;}
#banner{height: 325px; background:  #a30303 ;width: 100%;border-radius: 10px;}
.box{box-shadow: 0 7px 17px 0 rgba(88, 91, 111, 0.08); background-color: #f4f4f4;border-radius: 10px;padding: 10px 20px;    margin-bottom: 25px;}
.box h4{color: #1e212a; font-size: 22px; font-family: "almoni-dl", "Assistant", sans-serif; padding: 10px}
.pic_wrapper{position: absolute;left: 0px;height: 145px; background-size: contain;width: 200px;background-repeat: no-repeat;top: 0;border-radius: 10px 0 0 10px}
.pic_wrapper .fade_pic{height: 100%;width: 100%;background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.31416316526610644) 50%, rgba(0,0,0,1) 100%);
}
#dashboard_page
{

  #user_welcome { height: 145px; background: #000; padding: 25px 40px; line-height: 0.9; border-radius: 10px; margin-bottom: 25px;position: relative;
    span {   font-size: 33px; font-weight: 900; color: #ff005e;}
    h3 {  font-size: 39px; color: #fff; font-weight: normal; }
      label { display: block; font-size: 23px; color:rgba(255,255,255,0.6);}
  }
  
  .user_props {
    & { display: flex; margin-top: 40px; }
    .prop { flex:1 0 auto; padding-left: 20px;
      i { float: right; background: top center no-repeat; background-size:contain; width:60px; height: 60px; margin-left: 10px;}
      .texts {float: right; line-height: normal;}
      span { display: block; font-size: 50px; font-weight: bold; margin-top: -15px; }
      label { display: block; font-size: 20px; color:rgba(0,0,0,0.7);}
    }
  }

  .graph_chart { background: #eee; padding:25px; text-align: center; font-weight: bold; border:1px solid #aaa; margin-bottom: 25px; }
}


.item{
  .share{display: flex;padding: 25px;}
  .share{
    .icon{margin: 0 10px;font-size: 14px;border: 1px solid;padding: 0px;border-radius: 100%;line-height: 1px;cursor: pointer; width:30px; height: 30px; text-align: center; line-height: 30px;}
    .icon:hover{transform: scale(1.04);}
  }
  .texts{
    h4{color: #000 !important;padding-top: 25px;padding-right: 25px;}
  }
.num{
  &{    font-size: 51px;padding-top: 19px;color: #ff1661 !important;}
  p{    font-size: 17px; margin-top: 4px;}
}
.active{color: #ff1661;}
.option{
  &{text-align: center;padding-top: 9px;width: 10%;cursor: pointer;font-size: 16px;font-weight: 700;}
  .svg-inline--fa{    font-size: 35px;text-align: center;margin-bottom: -3px;}
}
}

</style>